/**
 * initialize slick carousel for .s-hero-v2 selectors
 */

import jQuery from 'jquery'

import * as lib from './../lib/lib'

export default class IframeResponsive {
  constructor(element) {
    if (!element) {
      return false
    }

    this.$element = jQuery(element)
    this.iframeW = this._getIframeDimension('width')
    this.iframeH = this._getIframeDimension('height')
    this.iframeRatio = this.iframeH / this.iframeW

    this._setIframe()

    jQuery(window).on('resize', () => {
      this._setIframe()
    })
  }

  _getIframeDimension(dimesion) {
    if (lib.hasValue(this.$element.attr(dimesion))) {
      return this.$element.attr(dimesion)
    }

    if (lib.hasValue(this.$element.attr('style'))) {
      return this.$element.css(dimesion).replace('px', '')
    }

    return null
  }

  _setIframe() {
    if (!lib.hasValue(this.iframeW) || !lib.hasValue(this.iframeH)) {
      return false
    }

    this.$element.removeAttr('style')

    // devices
    if (lib.scrDevices()) {
      const containerW = this.$element.parent().outerWidth()

      this.$element.attr('width', containerW)
      this.$element.attr('height', containerW * this.iframeRatio)

      return false
    }

    this.$element.attr('width', this.iframeW)
    this.$element.attr('height', this.iframeH)
  }
}
